import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './LevelUpNotification.css';

function LevelUpNotification({ level, bonusPoints, playerName, onClose }) {
  const [isVisible, setIsVisible] = useState(true);
  const [showBonus, setShowBonus] = useState(false);

  useEffect(() => {
    // Show bonus points after a short delay
    const timer = setTimeout(() => setShowBonus(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Auto-hide after 5 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 500); // Call onClose after fade out
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!isVisible) return null;

  return (
    <div className='level-up-overlay'>
      <div className='level-up-notification'>
        <div className='level-up-header'>
          <div className='level-up-emoji'>🎉</div>
          <h1>LEVEL UP!</h1>
          <div className='level-up-emoji'>🎉</div>
        </div>

        <div className='level-up-content'>
          <div className='player-name'>{playerName}</div>
          <div className='level-display'>
            <span className='level-shield'>🛡️</span>
            <span className='level-number'>Level {level}</span>
            <span className='level-shield'>🛡️</span>
          </div>

          {showBonus && (
            <div className='bonus-points'>
              <div className='bonus-label'>BONUS POINTS!</div>
              <div className='bonus-amount'>+{bonusPoints}</div>
            </div>
          )}
        </div>

        <button className='close-button' onClick={() => setIsVisible(false)}>
          <X />
        </button>
      </div>
    </div>
  );
}

export default LevelUpNotification;
